export const NewMsgSounds = [
  {
    title: "غیرفعال",
    value: "/assets/sounds/NewMsgSound/",
  },
  {
    title: "attentionseeker",
    value: "/assets/sounds/NewMsgSound/attentionseeker.mp3",
  },
  {
    title: "demonstrative",
    value: "/assets/sounds/NewMsgSound/demonstrative.mp3",
  },
  {
    title: "happyending",
    value: "/assets/sounds/NewMsgSound/happyending.mp3",
  },
  {
    title: "longchimesound",
    value: "/assets/sounds/NewMsgSound/longchimesound.mp3",
  },
  {
    title: "office2",
    value: "/assets/sounds/NewMsgSound/office2.mp3",
  },
  {
    title: "oringzw424",
    value: "/assets/sounds/NewMsgSound/oringzw424.mp3",
  },
  {
    title: "oringzw427",
    value: "/assets/sounds/NewMsgSound/oringzw427.mp3",
  },
  {
    title: "softbells",
    value: "/assets/sounds/NewMsgSound/softbells.mp3",
  },
  {
    title: "solemn",
    value: "/assets/sounds/NewMsgSound/solemn.mp3",
  },
  {
    title: "whatfriendsarefor",
    value: "/assets/sounds/NewMsgSound/whatfriendsarefor.mp3",
  },
  {
    title: "youhavenewmessage",
    value: "/assets/sounds/NewMsgSound/youhavenewmessage.mp3",
  },
  {
    title: "Sosumi",
    value: "/assets/sounds/NewMsgSound/Sosumi.mp3",
  },
  {
    title: "Submarine",
    value: "/assets/sounds/NewMsgSound/Submarine.mp3",
  },
  {
    title: "oringz",
    value: "/assets/sounds/NewMsgSound/oringz.mp3",
  },
  {
    title: "Tink",
    value: "/assets/sounds/NewMsgSound/Tink.mp3",
  },
  {
    title: "Basso",
    value: "/assets/sounds/NewMsgSound/Basso.mp3",
  },
  {
    title: "Blow",
    value: "/assets/sounds/NewMsgSound/Blow.mp3",
  },
  {
    title: "Bottle",
    value: "/assets/sounds/NewMsgSound/Bottle.mp3",
  },
  {
    title: "Frog",
    value: "/assets/sounds/NewMsgSound/Frog.mp3",
  },
  {
    title: "Funk",
    value: "/assets/sounds/NewMsgSound/Funk.mp3",
  },
  {
    title: "Glass",
    value: "/assets/sounds/NewMsgSound/Glass.mp3",
  },
  {
    title: "Hero",
    value: "/assets/sounds/NewMsgSound/Hero.mp3",
  },
  {
    title: "Morse",
    value: "/assets/sounds/NewMsgSound/Morse.mp3",
  },
  {
    title: "Ping",
    value: "/assets/sounds/NewMsgSound/Ping.mp3",
  },
  {
    title: "Pop",
    value: "/assets/sounds/NewMsgSound/Pop.mp3",
  },
  {
    title: "Purr",
    value: "/assets/sounds/NewMsgSound/Purr.mp3",
  },
];

export const NewMsgInConversationSounds = [
  {
    title: "غیرفعال",
    value: "/assets/sounds/NewMsgInConversationSound/",
  },
  {
    title: "attentionseeker",
    value: "/assets/sounds/NewMsgInConversationSound/attentionseeker.mp3",
  },
  {
    title: "demonstrative",
    value: "/assets/sounds/NewMsgInConversationSound/demonstrative.mp3",
  },
  {
    title: "happyending",
    value: "/assets/sounds/NewMsgInConversationSound/happyending.mp3",
  },
  {
    title: "longchimesound",
    value: "/assets/sounds/NewMsgInConversationSound/longchimesound.mp3",
  },
  {
    title: "office2",
    value: "/assets/sounds/NewMsgInConversationSound/office2.mp3",
  },
  {
    title: "oringzw424",
    value: "/assets/sounds/NewMsgInConversationSound/oringzw424.mp3",
  },
  {
    title: "oringzw427",
    value: "/assets/sounds/NewMsgInConversationSound/oringzw427.mp3",
  },
  {
    title: "softbells",
    value: "/assets/sounds/NewMsgInConversationSound/softbells.mp3",
  },
  {
    title: "solemn",
    value: "/assets/sounds/NewMsgInConversationSound/solemn.mp3",
  },
  {
    title: "whatfriendsarefor",
    value: "/assets/sounds/NewMsgInConversationSound/whatfriendsarefor.mp3",
  },
  {
    title: "youhavenewmessage",
    value: "/assets/sounds/NewMsgInConversationSound/youhavenewmessage.mp3",
  },
  {
    title: "Sosumi",
    value: "/assets/sounds/NewMsgInConversationSound/Sosumi.mp3",
  },
  {
    title: "Submarine",
    value: "/assets/sounds/NewMsgInConversationSound/Submarine.mp3",
  },
  {
    title: "oringz",
    value: "/assets/sounds/NewMsgInConversationSound/oringz.mp3",
  },
  {
    title: "Tink",
    value: "/assets/sounds/NewMsgInConversationSound/Tink.mp3",
  },
  {
    title: "Basso",
    value: "/assets/sounds/NewMsgInConversationSound/Basso.mp3",
  },
  {
    title: "Blow",
    value: "/assets/sounds/NewMsgInConversationSound/Blow.mp3",
  },
  {
    title: "Bottle",
    value: "/assets/sounds/NewMsgInConversationSound/Bottle.mp3",
  },
  {
    title: "Frog",
    value: "/assets/sounds/NewMsgInConversationSound/Frog.mp3",
  },
  {
    title: "Funk",
    value: "/assets/sounds/NewMsgInConversationSound/Funk.mp3",
  },
  {
    title: "Glass",
    value: "/assets/sounds/NewMsgInConversationSound/Glass.mp3",
  },
  {
    title: "Hero",
    value: "/assets/sounds/NewMsgInConversationSound/Hero.mp3",
  },
  {
    title: "Morse",
    value: "/assets/sounds/NewMsgInConversationSound/Morse.mp3",
  },
  {
    title: "Ping",
    value: "/assets/sounds/NewMsgInConversationSound/Ping.mp3",
  },
  {
    title: "Pop",
    value: "/assets/sounds/NewMsgInConversationSound/Pop.mp3",
  },
  {
    title: "Purr",
    value: "/assets/sounds/NewMsgInConversationSound/Purr.mp3",
  },
];

export const NewVisitorSounds = [
  {
    title: "غیرفعال",
    value: "/assets/sounds/NewVisitorSound/attentionseeker",
  },
  {
    title: "attentionseeker",
    value: "/assets/sounds/NewVisitorSound/attentionseeker.mp3",
  },
  {
    title: "demonstrative",
    value: "/assets/sounds/NewVisitorSound/demonstrative.mp3",
  },
  {
    title: "happyending",
    value: "/assets/sounds/NewVisitorSound/happyending.mp3",
  },
  {
    title: "longchimesound",
    value: "/assets/sounds/NewVisitorSound/longchimesound.mp3",
  },
  {
    title: "office2",
    value: "/assets/sounds/NewVisitorSound/office2.mp3",
  },
  {
    title: "oringzw424",
    value: "/assets/sounds/NewVisitorSound/oringzw424.mp3",
  },
  {
    title: "oringzw427",
    value: "/assets/sounds/NewVisitorSound/oringzw427.mp3",
  },
  {
    title: "softbells",
    value: "/assets/sounds/NewVisitorSound/softbells.mp3",
  },
  {
    title: "solemn",
    value: "/assets/sounds/NewVisitorSound/solemn.mp3",
  },
  {
    title: "whatfriendsarefor",
    value: "/assets/sounds/NewVisitorSound/whatfriendsarefor.mp3",
  },
  {
    title: "youhavenewmessage",
    value: "/assets/sounds/NewVisitorSound/youhavenewmessage.mp3",
  },
  {
    title: "Sosumi",
    value: "/assets/sounds/NewVisitorSound/Sosumi.mp3",
  },
  {
    title: "Submarine",
    value: "/assets/sounds/NewVisitorSound/Submarine.mp3",
  },
  {
    title: "oringz",
    value: "/assets/sounds/NewVisitorSound/oringz.mp3",
  },
  {
    title: "Tink",
    value: "/assets/sounds/NewVisitorSound/Tink.mp3",
  },
  {
    title: "Basso",
    value: "/assets/sounds/NewVisitorSound/Basso.mp3",
  },
  {
    title: "Blow",
    value: "/assets/sounds/NewVisitorSound/Blow.mp3",
  },
  {
    title: "Bottle",
    value: "/assets/sounds/NewVisitorSound/Bottle.mp3",
  },
  {
    title: "Frog",
    value: "/assets/sounds/NewVisitorSound/Frog.mp3",
  },
  {
    title: "Funk",
    value: "/assets/sounds/NewVisitorSound/Funk.mp3",
  },
  {
    title: "Glass",
    value: "/assets/sounds/NewVisitorSound/Glass.mp3",
  },
  {
    title: "Hero",
    value: "/assets/sounds/NewVisitorSound/Hero.mp3",
  },
  {
    title: "Morse",
    value: "/assets/sounds/NewVisitorSound/Morse.mp3",
  },
  {
    title: "Ping",
    value: "/assets/sounds/NewVisitorSound/Ping.mp3",
  },
  {
    title: "Pop",
    value: "/assets/sounds/NewVisitorSound/Pop.mp3",
  },
  {
    title: "Purr",
    value: "/assets/sounds/NewVisitorSound/Purr.mp3",
  },
];
